<template>
  <v-app>
    <v-container fluid>
      <v-row>
        <v-col cols="12">
          <v-expansion-panels v-model="panel">
            <v-expansion-panel>
              <v-expansion-panel-title
                color="blue-grey-lighten-4"
                class="panel-header"
                >Search Form
              </v-expansion-panel-title>
              <v-expansion-panel-text>
                <v-form @submit.prevent="loadReport">
                  <v-row class="px-2 py-2">
                    <v-col lg="4" md="4" cols="12">
                      <v-autocomplete
                        v-model="filters.supplier_id"
                        :items="supplierList"
                        :item-title="item => item.supplier_name"
                        item-value="id"
                        label="Filter by Supplier (Optional)"
                        density="compact"
                        prepend-inner-icon="mdi-account-outline"
                        variant="outlined"
                        bg-color="grey-lighten-4"
                        clearable
                        hide-details
                      ></v-autocomplete>
                    </v-col>

                    <v-col lg="2" md="2" cols="12">
                      <v-btn
                        class="bg-brand w-15"
                        type="submit"
                        :loading="loading"
                        prepend-icon="mdi-magnify"
                        >Search</v-btn
                      >
                    </v-col>
                  </v-row>
                </v-form>
              </v-expansion-panel-text>
            </v-expansion-panel>
          </v-expansion-panels>
        </v-col>
      </v-row>
    </v-container>

    <v-container fluid style="margin-top: -20px;">
      <v-row>
        <v-col cols="12">
          <v-expansion-panels v-model="panel1">
            <v-expansion-panel>
              <v-expansion-panel-title
                color="blue-grey-lighten-4"
                class="panel-header"
              >
                Supplier Wise LC Report
              </v-expansion-panel-title>
              <v-expansion-panel-text>
                <v-row class="py-2">
                  <v-col md="4" cols="12">
                    <v-text-field
                      v-model="search"
                      append-inner-icon="mdi-magnify"
                      label="Search"
                      single-line
                      hide-details
                      density="compact"
                      variant="outlined"
                      bg-color="grey-lighten-4"
                      class="pl-2"
                      clearable
                    ></v-text-field>
                  </v-col>

                  <v-col md="5" cols="12">
                    <div class="d-flex align-center flex-column">
                      <v-btn-group
                        v-if="reportData.length > 0"
                        variant="outlined"
                        density="compact"
                        size="x-small"
                        divided
                      >
                        <v-btn
                          prepend-icon="mdi mdi-download"
                          variant="flat"
                          color="success"
                          @click="exportToCSV"
                          >CSV</v-btn
                        >
                        <v-btn
                          prepend-icon="mdi mdi-download"
                          variant="flat"
                          color="primary"
                          @click="exportToExcel"
                          >EXCEL</v-btn
                        >
                        <v-btn
                          prepend-icon="mdi mdi-download"
                          variant="flat"
                          color="red"
                          @click="exportToPDF"
                          >PDF</v-btn
                        >
                      </v-btn-group>
                    </div>
                  </v-col>

                  <v-col md="3" cols="12">
                    <div class="text-right">
                      <v-chip
                        v-if="reportData.length > 0"
                        color="primary"
                        variant="tonal"
                        size="small"
                      >
                        Total: {{ reportData.length }}
                      </v-chip>
                    </div>
                  </v-col>
                </v-row>

                <v-data-table
                  :headers="headers"
                  :items="reportData"
                  :search="search"
                  :loading="loading"
                  item-value="id"
                  class="elevation-1"
                  density="compact"
                >
                  <template v-slot:item.index="{ index }">
                    {{ index + 1 }}
                  </template>

                  <template v-slot:item.lc_no="{ item }">
                    {{ item.lc_no }}
                  </template>

                  <template v-slot:item.code="{ item }">
                    {{ item.code || "-" }}
                  </template>

                  <template v-slot:item.supplier="{ item }">
                    {{ item.supplier?.supplier_name || "N/A" }}
                  </template>

                  <template v-slot:item.lc_open_date="{ item }">
                    {{ formatDate(item.lc_open_date) }}
                  </template>

                  <template v-slot:item.expiry_date="{ item }">
                    {{ formatDate(item.expiry_date) }}
                  </template>

                  <template v-slot:item.lc_amount="{ item }">
                    {{ $numberFormat(item.lc_amount) }}
                  </template>

                  <template v-slot:item.lc_status="{ item }">
                    <v-chip
                      :color="getLcStatusColor(item.lc_status)"
                      size="small"
                      variant="tonal"
                    >
                      {{ item.lc_status || "Draft" }}
                    </v-chip>
                  </template>

                  <template v-slot:no-data>
                    <div class="text-center pa-4">
                      <v-icon size="48" color="grey">mdi-database-search</v-icon>
                      <p class="text-grey mt-2">No LC data found</p>
                      <p class="text-caption text-grey">Click Search to load report data</p>
                    </div>
                  </template>
                </v-data-table>
              </v-expansion-panel-text>
            </v-expansion-panel>
          </v-expansion-panels>
        </v-col>
      </v-row>
    </v-container>
  </v-app>
</template>

<script>
import formatDateView from "@/plugins/dateFormatView";
import { ref, computed, onMounted } from "vue";
import { toast } from "vue3-toastify";
import { useStore } from "vuex";
import Axios from "axios";
import { getLcImportSupplierWiseReport } from "@/store/api";

export default {
  name: "LcImportSupplierWiseReport",
  setup() {
    const store = useStore();

    const panel = ref([0]);
    const panel1 = ref([0]);
    const loading = ref(false);
    const search = ref("");
    const reportData = ref([]);
    const filters = ref({
      supplier_id: null,
    });

    const headers = [
      { title: "#SL", align: "center", key: "index", width: "5%", sortable: false },
      { title: "LC No", key: "lc_no", align: "left", sortable: true },
      { title: "LC Code", key: "code", align: "left", sortable: true },
      { title: "Supplier", key: "supplier", align: "left", sortable: false },
      { title: "LC Open Date", key: "lc_open_date", align: "left", sortable: true },
      { title: "Expiry Date", key: "expiry_date", align: "left", sortable: true },
      { title: "LC Amount", key: "lc_amount", align: "right", sortable: true },
      { title: "LC Status", align: "center", key: "lc_status", sortable: true },
    ];

    const supplierList = computed(() => {
      return store.getters.getSupplierList || [];
    });

    const loadReport = async () => {
      try {
        loading.value = true;
        const params = {};
        if (filters.value.supplier_id) {
          params.supplier_id = filters.value.supplier_id;
        }

        const response = await Axios.get(getLcImportSupplierWiseReport, { params });
        reportData.value = response.data || [];
        
        if (reportData.value.length === 0) {
          toast.info("No LC data found for the selected criteria");
        } else {
          toast.success(`Loaded ${reportData.value.length} LC record(s)`);
        }
      } catch (error) {
        toast.error(error.response?.data?.message || "Failed to load supplier wise LC report");
        reportData.value = [];
      } finally {
        loading.value = false;
      }
    };

    const formatDate = (date) => {
      if (!date) return "";
      return formatDateView(date);
    };

    const getLcStatusColor = (status) => {
      const colors = {
        Draft: "grey",
        Open: "info",
        Amended: "warning",
        Shipped: "success",
        "Document-Received": "primary",
        Cleared: "success",
        Closed: "default",
        Cancelled: "error",
      };
      return colors[status] || "default";
    };

    const exportToCSV = () => {
      toast.info("CSV export feature coming soon");
    };

    const exportToExcel = () => {
      toast.info("Excel export feature coming soon");
    };

    const exportToPDF = () => {
      toast.info("PDF export feature coming soon");
    };

    onMounted(async () => {
      // Load supplier list for filter dropdown
      if (store.getters.getSupplierList.length === 0) {
        try {
          await store.dispatch("getSupplierList", {});
        } catch (error) {
          console.error("Failed to load supplier list:", error);
        }
      }
    });

    return {
      panel,
      panel1,
      loading,
      search,
      reportData,
      filters,
      headers,
      supplierList,
      loadReport,
      formatDate,
      getLcStatusColor,
      exportToCSV,
      exportToExcel,
      exportToPDF,
    };
  },
};
</script>

<style scoped>
.panel-header {
  font-weight: 600;
}
</style>

